import clsx from "clsx";
import React, { memo, ReactElement } from "react";

export enum EBadgeKind {
  INFO = "INFO",
  DANGER = "DANGER",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
}

interface IBadge {
  kind?: EBadgeKind;
  icon?: ReactElement;
  text?: string;
  onClick?: (text: any) => void;
  hasBackground?: boolean;
  className?: string;
}

const Badge: React.FC<IBadge> = ({
  kind = EBadgeKind.INFO,
  icon,
  text,
  onClick = () => {},
  hasBackground = true,
  className,
}) => {
  const theClasses = () => {
    switch (kind) {
      case EBadgeKind.DANGER: {
        return [
          "md:text-xs text-xs",
          "px-3",
          "py-0.5",
          "rounded",
          {
            "bg-red-100 dark:bg-teal-300": hasBackground,
            "text-red-500 dark:text-teal-800": hasBackground,
          },
        ];
      }
      case EBadgeKind.SUCCESS: {
        return [
          "text-green-800",
          "md:text-xs text-xs",
          // "font-medium",
          "me-2",
          "px-2.5",
          "py-0.5",
          "rounded",
          {
            "bg-green-100": hasBackground,
            "dark:bg-green-900": hasBackground,
          },
          "dark:text-green-300",
        ];
      }
      case EBadgeKind.WARNING: {
        return [
          "text-yellow-800",
          "md:text-xs text-xs",
          // "font-medium",
          "me-2",
          "px-2.5",
          "py-0.5",
          "rounded",
          {
            "bg-yellow-100": hasBackground,
            "dark:bg-yellow-900": hasBackground,
          },
          "dark:text-yellow-300",
        ];
      }
      default: {
        return [
          "text-white",
          "dark:text-gray-100",
          "md:text-xs text-xs",
          "px-3",
          "py-0.5",
          "rounded",
          {
            "!bg-blue-50 dark:!bg-gray-600": hasBackground,
            "!text-blue-600 dark:!text-white": hasBackground,
          },
        ];
      }
    }
  };

  return (
    <div
      className={clsx([
        "inline-flex",
        "flex-row",
        "gap-1",
        "items-center",
        "truncate",
        ...theClasses(),
        className,
      ])}
      onClick={() => onClick(text)}
    >
      {icon && icon}
      {text && <span className={clsx(["truncate", "font-light"])}>{text}</span>}
    </div>
  );
};

export default memo(Badge);
